import { money } from "../../lib/api";
import { CASES } from "../../lib/manualKit";

const TONE = { won: "text-brand border-brand", lost: "text-red-400 border-red-400", refunded: "text-amber-300 border-amber-300" };

export const CaseStudies = () => (
  <div data-testid="manual-cases">
    <p className="text-xs text-white/45 mb-5" data-testid="cases-disclaimer">Illustrative examples. Anonymized, composite scenarios built to show how evidence decides outcomes. They are not real customer results.</p>
    <div className="grid md:grid-cols-2 gap-4">
      {CASES.map((c) => (
        <article key={c.id} className="panel panel-hover p-5" data-testid={`case-${c.id}`}>
          <div className="flex items-center justify-between gap-3">
            <span className="font-mono text-[9px] tracking-[0.18em] text-white/40">ILLUSTRATIVE EXAMPLE · #{c.id}</span>
            <span className={`font-mono text-[10px] tracking-wider px-2 py-0.5 border uppercase ${TONE[c.outcome]}`} data-testid={`case-outcome-${c.id}`}>{c.outcome}</span>
          </div>
          <p className="font-mono text-3xl font-extrabold mt-3">{money(c.amount)}</p>
          <p className="text-sm text-white/70 mt-1">{c.industry} · {c.code}</p>
          <p className="label-xs mt-4">Evidence gathered</p><p className="text-sm text-white/75 mt-1">{c.evidence}</p>
          <p className="label-xs mt-4">Lesson</p><p className="text-sm text-accent2 mt-1">{c.lesson}</p>
        </article>
      ))}
    </div>
  </div>
);
